// extracted by mini-css-extract-plugin
export var cardHeader = "_s7-0";
export var reorderHandle = "_s7-3";
export var titleArea = "_s7-1";
export var titleAreaWithHandle = "_s7-2";